import { render, staticRenderFns } from "./AlertBar.vue?vue&type=template&id=4cc33689&scoped=true"
import script from "./AlertBar.vue?vue&type=script&lang=js"
export * from "./AlertBar.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=4cc33689&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc33689",
  null
  
)

export default component.exports